/**
 * Étape « Curieux » de l'onboarding : ce qu'il trouvera, et le niveau qu'il veut
 * réviser (facultatif, mémorisé sur l'appareil — même clé que l'Accueil, JeJoue
 * et le Live School du Feed). Aucune écriture en base.
 */

import { useState } from 'react';
import { Button, cn } from '@jeraisonne/ui';
import { SECONDARY_SCHOOL_LEVELS, type SchoolLevel } from '@jeraisonne/db';
import { readStoredPlayerLevel, storePlayerLevel } from '@/lib/player/overview';
import { OnboardingFooter } from '@/features/onboarding/onboarding-ui';

export function PlayerOnboardingStep({
  loading,
  onFinish,
}: {
  loading: boolean;
  onFinish: () => void;
}) {
  const [level, setLevel] = useState<SchoolLevel | null>(() => readStoredPlayerLevel());

  function pick(next: SchoolLevel) {
    setLevel(next);
    storePlayerLevel(next);
  }

  return (
    <div className="space-y-5">
      <ul className="text-ink-700 space-y-2 text-sm">
        <li>
          <strong>JeJoue</strong> : des exercices de la 6e à la Terminale, à faire quand tu veux.
        </li>
        <li>
          <strong>Tes SKILLCARDS</strong> : chaque exercice travaille des méthodes et théorèmes ;
          réponds juste pour faire monter leur maîtrise.
        </li>
        <li>
          <strong>Un bilan de niveau</strong> en 15 questions, quand tu veux, pour savoir où tu en
          es.
        </li>
      </ul>

      <fieldset className="space-y-2">
        <legend className="text-ink-900 text-sm font-semibold">
          Quel niveau veux-tu réviser ?{' '}
          <span className="text-ink-500 font-normal">(facultatif)</span>
        </legend>
        <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
          {SECONDARY_SCHOOL_LEVELS.map((l) => (
            <button
              key={l.value}
              type="button"
              aria-pressed={level === l.value}
              onClick={() => pick(l.value)}
              className={cn(
                'min-h-[2.75rem] rounded-xl border-2 px-2 text-sm font-semibold active:scale-[0.98]',
                level === l.value
                  ? 'border-primary-500 bg-primary-50 text-primary-700'
                  : 'border-ink-200 text-ink-700 ocean:bg-white/5 bg-white',
              )}
            >
              {l.label}
            </button>
          ))}
        </div>
        <p className="text-ink-500 text-xs">
          Tu pourras le changer à tout moment depuis ton accueil.
        </p>
      </fieldset>

      <OnboardingFooter>
        <Button
          type="button"
          variant="primary"
          size="lg"
          fullWidth
          loading={loading}
          onClick={onFinish}
        >
          Aller à mon accueil
        </Button>
      </OnboardingFooter>
    </div>
  );
}
